import { render, staticRenderFns } from "./DmhF2F.vue?vue&type=template&id=0d67dfbc"
import script from "./DmhF2F.vue?vue&type=script&lang=js"
export * from "./DmhF2F.vue?vue&type=script&lang=js"
import style0 from "./DmhF2F.vue?vue&type=style&index=0&id=0d67dfbc&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports